import type { ReactNode } from 'react'

type SignupSectionProps = {
  title: string
  subtitle?: string
  children: ReactNode
}

export const SignupSection = ({ title, subtitle, children }: SignupSectionProps) => (
  <section className="space-y-4">
    <div className="space-y-1.5">
      <h2 className="text-base font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      {subtitle ? <p className="text-sm leading-relaxed text-(--color-text-secondary)">{subtitle}</p> : null}
    </div>
    {children}
  </section>
)
